import createConcurrencyIntervalStream from './Streams/createConcurrencyIntervalStream';
import subscribeToConcurrencyInterval from './Subscribers/subscribeToConcurrencyInterval';

const connectConcurrencyApiSubscriptions = middleware => [
    subscribeToConcurrencyInterval(
        createConcurrencyIntervalStream(middleware.state.stores.concurrency.update$),
        middleware.apiServices.concurrency.request$,
    ),
];

export default connectConcurrencyApiSubscriptions;
